import { render, staticRenderFns } from "./AddTrajectory.vue?vue&type=template&id=3325b46f&scoped=true"
import script from "./AddTrajectory.vue?vue&type=script&lang=js"
export * from "./AddTrajectory.vue?vue&type=script&lang=js"
import style0 from "./AddTrajectory.vue?vue&type=style&index=0&id=3325b46f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325b46f",
  null
  
)

export default component.exports